import React from 'react';
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import SimActivationProcessDetails from './SimActivationProcessDetails';





class Routes  extends React.Component {

    render(){        
        return <Switch>
            <Route exact path="/sim-activation-process/details/:id" component={SimActivationProcessDetails} />
        </Switch>
    }
}

export default Routes;